import moment from 'jalali-moment'
import React from 'react'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
import { MoneyPoolTransactionTypes } from 'utilities/helper/moneyPools'
interface IItemProps {
    item: ICashinCashoutFinancial
}
export default function Item({ item }: IItemProps) {
    return (
        <div className="bg-main-bg px-2 py-1 items-center my-2 mx-2 rounded-md">
            <div className=" items-center flex justify-between">
                <p className=" text-sm">{item.amount.toLocaleString()} تومان</p>
                <p>{item.poolship_name}</p>
                <div className=" text-sm text-left">
                    <p>
                        {item?.jalali_time &&
                            ConvertJalaliDate(item.jalali_time)}
                    </p>
                    <p>
                        {moment
                            .from(
                                item.jalali_time,
                                'fa',
                                'jYYYY-jM-jD HH:mm:ss'
                            )
                            .format('HH:mm:ss')}
                    </p>
                    <p>{MoneyPoolTransactionTypes[item.type]}</p>
                </div>
            </div>
            {item.tag && (
                <div>
                    <hr />
                    <p className=" text-sm my-1">توضیحات: {item.tag}</p>
                </div>
            )}
        </div>
    )
}
